import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface PickupDateTimeState {
  pickupDate: Date | null;
  pickupTime: string | null;
  setPickupDateTime: (date: Date, time: string) => void;
  setPickupDate: (date: Date | null) => void;
  setPickupTime: (time: string | null) => void;
  clearPickupDateTime: () => void;
  getFormattedDateTime: () => string | null;
}

export const usePickupDateTimeStore = create<PickupDateTimeState>()(
  persist(
    (set, get) => ({
      pickupDate: null,
      pickupTime: null,

      setPickupDateTime: (date: Date, time: string) => {
        set({
          pickupDate: date,
          pickupTime: time,
        });
      },

      setPickupDate: (date: Date | null) => {
        set({
          pickupDate: date,
        });
      },

      setPickupTime: (time: string | null) => {
        set({
          pickupTime: time,
        });
      },

      clearPickupDateTime: () => {
        set({
          pickupDate: null,
          pickupTime: null,
        });
      },

      getFormattedDateTime: () => {
        const state = get();
        if (!state.pickupDate || !state.pickupTime) return null;

        const [hours, minutes] = state.pickupTime.split(':');
        const dateTime = new Date(state.pickupDate);
        dateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);

        return dateTime.toISOString();
      },
    }),
    {
      name: 'pickup-datetime-storage',
      storage: createJSONStorage(() => localStorage, {
        replacer: (key, value) => {
          if (key === 'pickupDate' && value instanceof Date) {
            return value.toISOString();
          }
          return value;
        },
        reviver: (key, value) => {
          if (key === 'pickupDate' && typeof value === 'string') {
            return new Date(value);
          }
          return value;
        },
      }),
      partialize: state => ({
        pickupDate: state.pickupDate,
        pickupTime: state.pickupTime,
      }),
    }
  )
);
